import React, { useState, Fragment } from "react";

import { DataGrid } from "@mui/x-data-grid";
import Box from "@mui/material/Box";
import Card from "@mui/material/Card";
import IconButton from "@mui/material/IconButton";
import Switch from "@mui/material/Switch";
import PencilOutline from "mdi-material-ui/PencilOutline";
import DeleteOutline from "mdi-material-ui/DeleteOutline";
import _ from "lodash";
import { useTheme } from "@mui/material/styles";
import QuickSearchToolbar from "views/components/QuickSearchToolbar";
import DialogModal from "@core/components/dialogmodal";
import { isPermissionAllow } from "@core/utils/IsPermissionAllow";

const DonationTypeList = (props) => {
  const {
    handleDeleteModal,
    deleteOpen,
    handleOpen,
    donationList,
    pageSize,
    searchText,
    pageNumber,
    setPageSize,
    setSearchText,
    setPageNumber,
    totalRecord,
    handleDonationStatusChange,
    role,
    permission,
  } = props;

  const theme = useTheme();

  const handleClick = (status, id, checkType) => {
    handleDonationStatusChange(!status, id, checkType);
  };
  const [deleteId, setDeleteId] = useState(null);
  const [selectedRows, setSelectedRows] = useState([]);

  const handleEdit = (id) => {
    handleOpen("edit", id);
  };

  const handleDelete = (id) => {
    handleDeleteModal();
    setDeleteId(id);
  };

  const columns = [
    {
      flex: 0.3,
      minWidth: 80,
      field: "index",
      headerName: "Index",
    },
    {
      flex: 1,
      minWidth: 130,
      field: "title",
      headerName: "donation type",
    },
    {
      flex: 1.5,
      minWidth: 130,
      field: "home_desc",
      headerName: "Description",
    },
    {
      flex: 1,
      minWidth: 100,
      field: "amount",
      headerName: "Amount",
    },
    {
      flex: 1,
      minWidth: 100,
      field: "status",
      headerName: "Active",
      renderCell: ({ row }) => {
        const status = row.status;
        return (
          <Switch
            checked={status}
            size={"small"}
            style={{ color: theme.palette.primary.light }}
            onChange={() => handleClick(status, row.id, 'status')}
          />
        );
      },
    },
    {
      flex: 1,
      minWidth: 100,
      field: "show_at_home",
      headerName: "Home Status",
      renderCell: ({ row }) => {
        const status = row.show_at_home;
        return (
          <Switch
            checked={status}
            size={"small"}
            style={{ color: theme.palette.primary.light }}
            onChange={() => handleClick(status, row.id, '')}
          />
        );
      },
    },
    {
      flex: 1,
      minWidth: 100,
      field: "action",
      headerName: "Actions",
      renderCell: ({ row }) => {
        return (
          <Box sx={{ display: "flex", alignItems: "center" }}>
            <Box
              sx={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "space-between",
              }}
            >
              {((permission.edit && role === "2") || role === "1") && (
                <IconButton onClick={() => handleEdit(row.id)}>
                  <PencilOutline fontSize="medium" />
                </IconButton>
              )}
              {((permission.delete && role === "2") || role === "1") && (
                <IconButton onClick={() => handleDelete(row.id)}>
                  <DeleteOutline fontSize="medium" />
                </IconButton>
              )}
            </Box>
          </Box>
        );
      },
    },
  ];
  const removeaction =
    !permission.edit && !permission.delete && role === "2"
      ? _.dropRight(columns)
      : columns;
  const handleSearch = (searchValue) => {
    setSearchText(searchValue);
  };

  const assemList = donationList.map((data, index) => {
    return {
      index: index + pageSize * pageNumber + 1,
      ...data,
      desc: 'Description',
      descStatus: 0
    };
  });

  return (
    <Fragment>
      <Card sx={{ width: "100%", overflowInline: "hidden" }}>
        <DataGrid
          hideFooterSelectedRowCount
          autoHeight
          localeText={{ noRowsLabel: "No results found" }}
          rowCount={Number(totalRecord)}
          page={pageNumber}
          columns={removeaction}
          rows={assemList}
          pageSize={pageSize}
          rowsPerPageOptions={[10, 25, 50]}
          pagination
          paginationMode="server"
          components={{
            Toolbar: QuickSearchToolbar,
          }}
          onPageChange={(newPageNumber) => setPageNumber(newPageNumber)}
          onPageSizeChange={(newPageSize) => setPageSize(newPageSize)}
          onSelectionModelChange={(rows) => setSelectedRows(rows)}
          checkboxSelection={isPermissionAllow(permission.delete, role)}
          disableSelectionOnClick
          componentsProps={{
            toolbar: {
              value: searchText,
              clearSearch: () => handleSearch(""),
              onChange: (event) => handleSearch(event.target.value),
              handleOpen: () => handleOpen("add", ""),
              title: isPermissionAllow(permission.edit, role)
                ? "Add Donation Type"
                : "",
              isSearch: false,
              selectedRows: selectedRows,
              multiDelete: isPermissionAllow(permission.delete, role),
              onClickDelete: () => handleDeleteModal(),
            },
          }}
          sx={{
            ".MuiTablePagination-displayedRows": {
              marginTop: "1rem",
            },
            ".MuiTablePagination-selectLabel": {
              marginTop: "1.1rem",
            },
            ".MuiInputBase-root": {
              marginTop: "0.2rem",
            },
          }}
        />
      </Card>

      {deleteOpen && (
        <DialogModal
          open={deleteOpen}
          handleClose={() => handleDeleteModal()}
          handleDelete={() =>
            handleDeleteModal(
              selectedRows && selectedRows.length === 0
                ? [deleteId]
                : selectedRows
            )
          }
        />
      )}
    </Fragment>
  );
};

export default DonationTypeList;
